import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          影迷评价
        </h2>
        <p className="text-foreground-500 text-center text-sm md:text-base mb-10">
          来自真实影迷的观影反馈，听听他们怎么说
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {commentItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
          {commentItems.slice(3).map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}